import { gql } from 'graphql-request';

import {
  CompanyTabCompanyID,
  CompanyTabCreatedAt,
  CompanyTabID,
  CompanyTabName,
  CompanyTabNanoID,
  CompanyTabPosition,
  CompanyTabType,
  CompanyTabUpdatedAt,
  CompanyTabUser,
  CompanyTabUserID,
  CompanyTabUUID
} from '../companyTabsTypes';

import { UpdateItemGqlError } from '../../../types';

export interface UpdateCompanyTabQueryResponse {
  updateCompanyTab: {
    status: string;
    recordUuid: CompanyTabUUID;
    record: {
      id: CompanyTabID;
      uuid: CompanyTabUUID;
      nanoId: CompanyTabNanoID;
      name: CompanyTabName;
      content: string | null;
      position: CompanyTabPosition;
      type: CompanyTabType;
      createdAt: CompanyTabCreatedAt;
      updatedAt: CompanyTabUpdatedAt;
      userId: CompanyTabUserID;
      user: CompanyTabUser;
      companyId: CompanyTabCompanyID;
    };
    errors: {
      name: UpdateItemGqlError;
      content: UpdateItemGqlError;
      position: UpdateItemGqlError;
      fullMessages: string[];
    };
  };
}

export const UPDATE_COMPANY_TAB_QUERY = gql`
  mutation UpdateCompanyTab(
    $uid: Uid!
    $name: String
    $content: String
    $position: Int
  ) {
    updateCompanyTab(
      input: { uid: $uid, name: $name, content: $content, position: $position }
    ) {
      errors {
        fullMessages
        name
        content
        position
      }
      record {
        content
        createdAt
        id
        name
        nanoId
        position
        type
        updatedAt
        userId
        uuid
        user {
          id
          nanoId
        }
        companyId
      }
      recordUuid
      status
    }
  }
`;
